
/**
 * A custom markdown parser, explained below in the comments
 */

// *italic*, >bold>, _underline_, #highlight#, superscript^2^, subscript<2<, ~30~30 font size, ~15~switching back to 15 font size, line break,` escaped characters: \\* \\_ \\# \\> \\^ \\~ \\\\, everything: e*v>e_r#y^t<h<~20~i~30~n~40~g#_>*

// * will turn on italic, then the next * turns it off

// ~50~ will use font size 50 forever until another font size is specified

// line breaks are either \n as a char code or ` as an actual character, because sometimes \n doesn't convert into a char code but literally two characters "\n", so just use `, but \n will still work

export function markdownParse(string) {
    var html = [];

    var italic = false,
        bold = false,
        underline = false,
        highlight = false,
        superscript = false,
        subscript = false;

    var fontSize = "15px";
    var symbols = ["*", ">", "#", "_", "^", "<", "~", "\n", "`"];

    for (var c = 0; c < string.length; c++) {
        var lineBreak = false;
        var changedStyle = true;


        switch (string[c]) {
            case "*":
                italic = !italic;
                break;
            case ">":
                bold = !bold;
                break;
            case "#":
                highlight = !highlight;
                break;
            case "_":
                underline = !underline;
                break;
            case "^":
                superscript = !superscript;
                subscript = false;
                break;
            case "<":
                subscript = !subscript;
                superscript = false;
                break;
            case "~":
                var size = "";
                c++;
                while (c < string.length && string[c] != "~") {
                    size += string[c];
                    c++;
                }
                fontSize = size + "px";
                break;

            case "\n":
                lineBreak = true;
                break;

            case "`":
                lineBreak = true;
                break;

            default:
                changedStyle = false;
                break;
        }


        if (c == 0 && !changedStyle){
            changedStyle = true;
            c--;
        }


        if (changedStyle) {
            var divContent = "";
            c++;
            while (c < string.length && !symbols.includes(string[c])) {
                if (string[c] == "\\") {
                    c++;
                }
                divContent += string[c];
                c++;
            }
            c--;

            var divStyle = {};
            divStyle.fontSize = fontSize;
            if (italic) {
                divStyle.fontStyle = "italic";
            }
            if (bold) {
                divStyle.fontWeight = "bold";
            }
            else {
                divStyle.fontWeight = "100"; // because managment team app likes light font weight
            }
            if (underline) {
                divStyle.textDecoration = "underline";
            }
            if (highlight) {
                divStyle.backgroundColor = "#ffff00";
            }

            if (superscript) {
                html.push(<sup style={divStyle} key={html.length}>{lineBreak ? <br /> : ""}{divContent}</sup>);
            } else if (subscript) {
                html.push(<sub style={divStyle} key={html.length}>{lineBreak ? <br /> : ""}{divContent}</sub>);
            } else {
                html.push(<span style={divStyle} key={html.length}>{lineBreak ? <br /> : ""}{divContent}</span>);
            }
        }
    }

    return <>{html.map((item) => item)}</>;
}
